import http from './httpRequest.js'

/**
 * 访客注册/登录
 * @param {number} sid 业务员userId
 * @param {string} did 浏览器持久化设备ID(localStorage), 并入设备指纹,
 *                     避免同公网IP+同型号手机的多位客户指纹碰撞合并成同一人
 * @returns {Promise<{accessToken,accessTokenExpiresIn,guestId,guestName,guestAvatar,salespersonId,salespersonName,salespersonAvatar}>}
 */
export function guestRegister(sid, did) {
	return http({
		url: '/public/guest/register',
		method: 'post',
		params: { sid: sid, did: did || '' }
	})
}

/**
 * 拉取离线私聊消息
 * @param {number} minId 最小消息id(传0拉全部)
 * @returns {Promise<Array>}
 */
export function loadOfflineMessage(minId) {
	return http({
		url: '/message/private/loadOfflineMessage',
		method: 'get',
		params: { minId: minId || 0 }
	})
}

/**
 * 发送私聊消息
 * @param {string} localId 本地消息id(雪花算法)
 * @param {number} recvId 接收用户id
 * @param {string} content 消息内容
 * @param {number} type 消息类型 0:文字 1:图片
 * @returns {Promise<Object>}
 */
export function sendPrivateMessage(localId, recvId, content, type) {
	return http({
		url: '/message/private/send',
		method: 'post',
		data: { localId, recvId, content, type: type || 0 }
	})
}

/**
 * 拉取历史消息(上翻加载)
 * @param {number} friendId 好友id
 * @param {number} maxSeqNo 最大消息序号(传0或不传拉最新)
 * @returns {Promise<Array>}
 */
export function loadHistoryMessage(friendId, maxSeqNo) {
	return http({
		url: '/message/private/history',
		method: 'post',
		data: { friendId, maxSeqNo: maxSeqNo || 0, minSeqNo: 0 }
	})
}
